import React, { Component, Fragment } from 'react';
import { Body, Title, Micro } from '@vds/typography';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { Grid, Row, Col } from '@vds/grids';
import { Modal, ModalBody } from '@vds/modals';
import './FourGPlan.css';
import FourGPlanPage from './FourGPlan';
import FiveGPlanPage from '../FiveGPlans/FiveGPlan';
import CBandPlanPage from '../CBandPlans/CBandPlan';
import { Line } from '@vds/lines';
import queryString from "query-string";
import { TextLink } from '@vds/buttons';
import Icon from '@vds/icons';


const BodyWrapper = styled.main`
	margin: 0 auto;
	width: 100%;
`;

const StrikeThrough = styled.span`
  text-decoration: line-through;
  color: #bfbfbf;
  margin-bottom: -10px;
`;

const OfferPricingModal = styled(Modal)`
height: auto;
width: 45%;
min-height: 8rem;
> div:first-child {overflow:hidden}

`;
const OfferPricingModalBody = styled(ModalBody)`
padding: 0 16px;
`;

const MarginSpacerM = styled.div`margin-top: 1rem !important;`;

class InternetPlanStatic extends Component {
	constructor(props) {
		super(props);
		this.myRef = React.createRef();
		this.state = {
            endInteraction: false,
        };
	}
	componentDidMount(){
		document.title = 'BI Qualification Tool'
		this.setState({ endInteraction: true });
	}

	componentDidUpdate = () => {
        if(this.state.endInteraction && navigator?.userAgentData?.platform !== "macOS") {
            window.newrelic.interaction().end();
            this.setState({ endInteraction: false });
        }
    }

	handleScroll = () => {
		if (this.myRef.current) {
			let setValue = this.myRef.current.getBoundingClientRect().top <= 110;
			//   this.setState({isSticky: setValue});
		}
	};

	render() {
		let { saveBulkAddress, hasMultipleAddress } = this.props; 
 
	return (
			<BodyWrapper>
				<div className="Customize-Order">
					<div id="dvAutopay" className="hideSection"></div>
						<Grid colSizes={{ mobile: 4, desktop: 12, tablet: 12 }} colGutter={false}>
							<Line type="xLight" className="mar-0" />
							<Row>
							<TextLink
                                        iconPosition="left"
                                        onClick={(e) => {
                                            if(hasMultipleAddress)
                                            this.props.history.go(-2);
											else
											this.props.history.goBack();
                                        }}
                                        className="back-link-text ip-static-page"
                                    >
										<span className="arrow-icon">
                                            <Icon name="caret-left" size="small" />
                                        </span>
                                        <span>Go back</span>
									</TextLink>
							</Row>
							<Row>
								{saveBulkAddress&&saveBulkAddress.length? 
								<Col colSizes={{ mobile: 4, desktop: 12, tablet: 12 }}>
									{ saveBulkAddress? saveBulkAddress.map((item)=>{
										return(
											<div>
												<div  className='address-header'>																			
													<Title size="large">
														{item?.location?.formattedAddress}
													</Title>
												</div>	
												
												{item?.qualification?.Qualified4G === "Y" && item?.qualification?.QualifiedCBand === "N" &&item?.qualification?.Qualified5G === "N"? 
															<FourGPlanPage hasMultipleAddress={hasMultipleAddress}></FourGPlanPage>
															:
														item?.qualification?.QualifiedCBand === "Y" && item?.qualification?.Qualified5G === "Y"?
														
														<CBandPlanPage hasMultipleAddress={hasMultipleAddress} fiveGQualified = 'Y'></CBandPlanPage>
														: item?.qualification?.QualifiedCBand === "N" && item?.qualification?.Qualified5G === "Y"?

															<FiveGPlanPage hasMultipleAddress={hasMultipleAddress}></FiveGPlanPage>
														: item?.qualification?.QualifiedCBand === "Y" && item?.qualification?.Qualified5G === "N"?

															<CBandPlanPage hasMultipleAddress={hasMultipleAddress}></CBandPlanPage>
														:
														item?.qualification === null||item?.qualification=== undefined ?<FourGPlanPage hasMultipleAddress={hasMultipleAddress}></FourGPlanPage>:null
												}
												<Line type="xLight" className="mar-0" />
													
											</div>
											);
										}) : ''
									}
								</Col>:
								<Col colSizes={{ mobile: 4, desktop: 12, tablet: 12 }}>
										<div>
											<FourGPlanPage></FourGPlanPage>
											<Line type="xLight" className="mar-0" />
										</div>
							</Col>
								}
							</Row>								
						</Grid>
					</div>
			</BodyWrapper >
		);
	}
}

const mapStateToProps = state => {
	const { BulkAddressValidationPage } = state;

	return {
		saveBulkAddress: BulkAddressValidationPage.saveBulkAddress,
		hasMultipleAddress: BulkAddressValidationPage.hasMultipleAddress

	}
}
// const mapDispatchToProps = (dispatch) => ({


// });
 InternetPlanStatic = connect(mapStateToProps)(InternetPlanStatic);

export default InternetPlanStatic;



